import { ACCEPT_WITHDRAWAL } from '../../routes';
import customAxios from "../../customAxios";
import {WithdrawalNamespace} from "../../../types/withdrawal.namespace";

const withdrawalAcceptOne = async (props: WithdrawalNamespace.propsUpdateOne): Promise<any> => {
  try {
    return (await customAxios.put(ACCEPT_WITHDRAWAL, props)).data;
  } catch (error: unknown) {
    console.error({ ACCEPT_WITHDRAWAL: error });
    return false;
  }
};

export default withdrawalAcceptOne;
